import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./globals.css.ts";
import "./sentry.ts";
import { App } from "./ui/App.tsx";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = document.getElementById("root")!;

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
